import type { SVGProps } from "react";
import { withCustomIcon } from "./withCustomIcon";

const HoldIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    className="tenera-icon"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor">
      <path
        fill="currentColor"
        d="M12,0C5.3726,0,0,5.3726,0,12s5.3726,12,12,12,12-5.3726,12-12S18.6274,0,12,0ZM12,23c-6.0654,0-11-4.9346-11-11S5.9346,1,12,1s11,4.9346,11,11-4.9346,11-11,11Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M9.7444,7.1165c-.2764,0-.5.2236-.5.5v8.7666c0,.2764.2236.5.5.5s.5-.2236.5-.5V7.6165c0-.2764-.2236-.5-.5-.5Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M14.2556,7.1165c-.2764,0-.5.2236-.5.5v8.7666c0,.2764.2236.5.5.5s.5-.2236.5-.5V7.6165c0-.2764-.2236-.5-.5-.5Z"
        className="accent"
      />
    </g>
  </svg>
);
export default withCustomIcon(HoldIcon);
